import Inbox from '@src/main/modules/messages/ui/mailbox/views/inbox/Inbox';
import Outbox from '@src/main/modules/messages/ui/mailbox/views/outbox/Outbox';
import { FC } from 'react';

interface MailboxTabContentProps {
  activeIndex: number;
  className?: string;
}

const MailboxTabContent: FC<MailboxTabContentProps> = ({ activeIndex, className }) => (
  <div className={className}>{activeIndex === 0 ? <Inbox /> : <Outbox />}</div>
);

export default MailboxTabContent;
